import React from "react";
import { numberWithCommas } from "../../utils/function";

const Card = ({ data, userData, type }) => {
  const cardData = [
    {
      title: "Fraction Owned",
      amount: (data && data?.fractionOwned) || "0"
    },
    {
      title: "Total Coin Earned",
      amount: (data && data?.totalCoinEarnedForAdmin) || "0"
    },
    {
      title: "Total Validated Block",
      amount: (data && data?.totalValidatedBlock) || "0"
    },
    {
      title: "Average Block Time",
      amount: `${data?.AverageBlockTimeInSecond || 0} Sec`
    }
  ];

  const cardData2 = [
    {
      title: "Total Commission",
      amount:
        (data &&
          numberWithCommas(Number(data?.commissionData?.totalNetCommission))) ||
        "0"
    },
    {
      title: "Withdraw Commission",
      amount:
        (data &&
          numberWithCommas(Number(data?.payoutData?.totalPayoutAmount))) ||
        "0"
    },
    {
      title: "Remaining Commission",
      amount:
        (data &&
          numberWithCommas(
            Number(data?.commissionData?.totalNetCommission) -
              Number(data?.payoutData?.totalPayoutAmount)
          )) ||
        "0"
    }
  ];

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6 mt-4 mb-4">
        {type == "one" ? (
          <>
            {" "}
            {cardData &&
              cardData?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={
                      "max-w-full overflow-hidden  bg-gradient-2 shadow-lg py-4 px-8 rounded-[20px] cursor-pointer hover:border-b-4 hover:border-b-[#69CEA6] transition transform hover:-translate-y-1"
                    }
                  >
                    <div className="py-2">
                      <h5 className="font-bold text-18 lg:text-2xl text-white mb-2 text-left flex items-center justify-between">
                        {item.title}
                      </h5>
                    </div>
                    <div className="flex justify-end">
                      <p className="break-all font-semibold text-26 lg:text-[30px] text-white flex items-center gap-2">
                        {item.amount}
                      </p>
                    </div>
                  </div>
                );
              })}{" "}
          </>
        ) : (
          <>
            {" "}
            {cardData2 &&
              cardData2?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={
                      "max-w-full overflow-hidden  bg-gradient-2 shadow-lg py-4 px-8 rounded-[20px] cursor-pointer hover:border-b-4 hover:border-b-[#69CEA6] transition transform hover:-translate-y-1"
                    }
                  >
                    <div className="py-2">
                      <h5 className="font-bold text-18 lg:text-2xl text-white mb-2 text-left flex items-center justify-between">
                        {item.title}
                      </h5>
                    </div>
                    <div className="flex justify-end">
                      <p className="break-all font-semibold text-26 lg:text-[30px] text-white flex items-center gap-2">
                        {item.amount}
                      </p>
                    </div>
                  </div>
                );
              })}
          </>
        )}
      </div>
    </>
  );
};
export default Card;
